import { forwardRef } from 'react';
import { RenderIf } from 'react-rainbow-components';
import PhoneIcon from 'components/icons/phone';
import {
    DropdownContainer,
    Header,
    CallsList,
    EmptyState,
    EmptyIcon,
    EmptyTitle,
    EmptyMessage,
} from './styled';
import { ActiveCall } from './types';
import CallElement from './CallElement';

interface ActiveCallsOverlayProps {
    calls: ActiveCall[];
    onCallClick?: (call: ActiveCall) => void;
    onViewCall?: (callId: string) => void;
}

const ActiveCallsOverlay = forwardRef<HTMLDivElement, ActiveCallsOverlayProps>(({
    calls = [],
    onCallClick,
    onViewCall,
}, ref) => (
    <DropdownContainer ref={ref}>
        <Header>
            Active Calls (
            {calls.length}
            )
        </Header>

        <RenderIf isTrue={calls.length === 0}>
            <EmptyState>
                <EmptyIcon>
                    <PhoneIcon />
                </EmptyIcon>
                <EmptyTitle>No Active Calls</EmptyTitle>
                <EmptyMessage>Start making calls to see them appear here</EmptyMessage>
            </EmptyState>
        </RenderIf>

        <RenderIf isTrue={calls.length > 0}>
            <CallsList>
                {calls.map((call) => (
                    <CallElement
                        key={call.id}
                        call={call}
                        onCallClick={onCallClick}
                        onViewCall={onViewCall}
                    />
                ))}
            </CallsList>
        </RenderIf>
    </DropdownContainer>
));

ActiveCallsOverlay.displayName = 'ActiveCallsOverlay';

export default ActiveCallsOverlay;
